// import { PagarPedidoReducer } from './pagarPedido/reducers/pagarPedidoReducers';
import { AprovarPedidoReducer } from './aprovarPedido/reducers/aprovarPedidoReducers';
import { combineReducers } from 'redux'
import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";
import { CampanhaPedidoResgateReducer } from 'domain/store/_carteira/campanhaPedidoResgate/reducers/campanhaPedidoResgateReducer';
import { CampanhaPedidoResgateAprovadosReducer } from 'domain/store/_carteira/campanhaPedidoResgate/reducers/campanhaPedidoResgateAprovadosReducer';
import { CarteiraBaseReducerList, RootStateBaseCarteira } from "domain/store/_carteira/carteiraBaseReducer";
import { PedidoLotesReducer } from './pedidoLotes/reducers/pedidoLotesReducers';
import { CampanhasReducer } from './campanha/reducer/campanhaReducers';
import { CampanhaProdutosReducer } from './produtos/reducer/CampanhaProdutosReducer';

const campanhaPedidoResgatePersistConfig = {
    key: "campanhaPedidoResgate",
    storage,
    whitelist: ["formData"],
};

const persistedCampanhaPedidoResgateReducer = persistReducer(
    campanhaPedidoResgatePersistConfig,
    CampanhaPedidoResgateReducer
);

// Estende o CarteiraBaseReducerList com os reducers específicos do projeto campanha
export const CampanhaReducerList = {
    ...CarteiraBaseReducerList,
    CampanhasReducer,
    // PagarPedidoReducer,
    AprovarPedidoReducer,
    PedidoLotesReducer,
    CampanhaProdutosReducer,
    CampanhaPedidoResgateReducer: persistedCampanhaPedidoResgateReducer,
    CampanhaPedidoResgateAprovadosReducer,
}
const CampanhaReducer = combineReducers(CampanhaReducerList);

export type RootStateCampanha = RootStateBaseCarteira & ReturnType<typeof CampanhaReducer>;

